// 生命周期状态
export interface LifecycleStatus {
  tenant_id: number;
  current_status: string;
  status_since: string;
  days_in_status: number;
  next_action: string;
  next_action_date: string;
  cancellation_cooldown_ends: string | null;
}

// 生命周期事件
export interface LifecycleEvent {
  id: number;
  tenant_id: number;
  event_type: string;
  from_status: string;
  to_status: string;
  reason: string;
  metadata: string;
  created_at: string;
}

// 数据导出任务
export interface DataExport {
  id: number;
  tenant_id: number;
  export_type: string; // proposals, influencers, campaigns, knowledge, all
  format: string; // csv, excel, json
  status: string; // pending, processing, completed, failed, expired
  file_path: string;
  file_size: number;
  error: string;
  expires_at: string;
  created_at: string;
}

// 创建导出请求
export interface CreateExportRequest {
  export_type: 'proposals' | 'influencers' | 'campaigns' | 'knowledge' | 'all';
  format: 'csv' | 'excel' | 'json';
}

// 注销请求
export interface CancelAccountRequest {
  reason: string;
}

// 导出类型显示名称
export const ExportTypeNames: Record<string, string> = {
  proposals: '提案数据',
  influencers: '红人数据',
  campaigns: '邀约数据',
  knowledge: '知识库数据',
  all: '全部数据',
};

// 导出格式显示名称
export const ExportFormatNames: Record<string, string> = {
  csv: 'CSV',
  excel: 'Excel',
  json: 'JSON',
};

// 导出状态显示名称
export const ExportStatusNames: Record<string, string> = {
  pending: '等待中',
  processing: '处理中',
  completed: '已完成',
  failed: '失败',
  expired: '已过期',
};

// 生命周期状态显示名称
export const LifecycleStatusNames: Record<string, string> = {
  trial: '试用中',
  active: '已激活',
  grace_period: '宽限期',
  frozen: '已冻结',
  frozen_trial: '试用冻结',
  cancelling: '注销中',
};

// 生命周期事件类型显示名称
export const LifecycleEventTypeNames: Record<string, string> = {
  trial_started: '开始试用',
  trial_expired: '试用到期',
  subscribed: '订阅成功',
  subscription_expired: '订阅到期',
  grace_period_started: '进入宽限期',
  frozen: '账户冻结',
  reactivated: '账户恢复',
  cancelling: '发起注销',
  cancelled: '注销完成',
  cleaned: '数据清理',
  cooldown_cancelled: '取消注销',
};

// 格式化文件大小
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  
  const units = ['B', 'KB', 'MB', 'GB'];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
  
  return `${size} ${units[i]}`;
}

// 获取状态对应的 Tag 颜色
export function getLifecycleStatusColor(status: string): string {
  const colorMap: Record<string, string> = {
    trial: 'blue',
    active: 'green',
    grace_period: 'orange',
    frozen: 'red',
    frozen_trial: 'red',
    cancelling: 'default',
  };
  return colorMap[status] || 'default';
}

// 获取导出类型对应的 Tag 颜色
export function getExportTypeColor(type: string): string {
  const colorMap: Record<string, string> = {
    proposals: 'blue',
    influencers: 'purple',
    campaigns: 'cyan',
    knowledge: 'green',
    all: 'gold',
  };
  return colorMap[type] || 'default';
}
